import React, { useState, useEffect, useRef } from "react";
import "../../css_files/Customer/CustomerEnquiryForm.css";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function CustomerEnquiryForm() {
  const [States, setStates] = useState([]);
  const [Cities, setCities] = useState([]);
  const formref = useRef();

  const initialState = {
    CompanyName: "",
    EnquiryType: "Service",
    ShippingAddress: {
      AddressType: "",
      AddressLine1: "",
      AddressLine2: "",
      Country: "India",
      State: "",
      City: "",
      Pincode: "",
    },
    IsSameAddress: false,
    BillingAddress: {
      AddressType: "",
      AddressLine1: "",
      AddressLine2: "",
      Country: "India",
      State: "",
      City: "",
      Pincode: "",
    },
    Customer: {
      Salutation: "",
      Name: "",
      Designation: "",
      PhoneNumber: "",
      Email: "",
    },
    Boiler: {
      Head: "",
      Series: "",
    },
    EnquiryDate: (() => {
      const date = new Date();
      const dateString = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      return dateString;
    })(),
    Priority: "",
    LookingFor: "",
  };

  const [enquiryForm, setEnquiryForm] = useState(initialState);

  function handleChange(e) {
    const { name, value } = e.target;
    if (name.includes(".")) {
      const keys = name.split(".");

      setEnquiryForm((prev) => {
        let updated = { ...prev };
        let nested = updated;

        for (let i = 0; i < keys.length - 1; i++) {
          nested[keys[i]] = { ...nested[keys[i]] };
          nested = nested[keys[i]];
        }

        nested[keys[keys.length - 1]] = value;

        return updated;
      });
    } else {
      setEnquiryForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/StateandCities/GetAllStates`)
      .then((res) => {
        setStates(res.data.sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch(console.log);
  }, []);

  function getCitiesbyState(stateId) {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/StateandCities/GetCitiesByStateId/${stateId}`
      )
      .then((res) => {
        setCities(res.data.sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch(console.log);
  }

  function handleSubmit(e) {
    e.preventDefault();
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/CustomerEnquiries`,
        enquiryForm
      )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data,
        }).then(() => formref.current.reset());
      })
      .catch(console.log);
  }

  return (
    <section className="customer-enquiry-form">
      <form onSubmit={handleSubmit} ref={formref}>
        <h1>Customer Enquiry Form</h1>
        <blockquote>
          <label>Enquiry Type</label>
          <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
            <input
              type="radio"
              name="EnquiryType"
              value="Service"
              required
              onChange={handleChange}
            />
            Service
            <input
              type="radio"
              name="EnquiryType"
              value="Parts"
              required
              onChange={handleChange}
            />
            Parts
          </blockquote>
        </blockquote>
        <blockquote>
          <label>Name of Company/Organization</label>
          <input
            type="text"
            placeholder="Enter Name of Company"
            required
            name="CompanyName"
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 200);
            }}
          />
        </blockquote>
        <div>
          <p>Shipping Address</p>
          <blockquote>
            <label>Address Type</label>
            <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
              <input
                type="radio"
                name="ShippingAddress.AddressType"
                value="Office"
                required
                onChange={handleChange}
              />
              Office
              <input
                type="radio"
                name="ShippingAddress.AddressType"
                value="Factory"
                required
                onChange={handleChange}
              />
              Factory
            </blockquote>
          </blockquote>
          <blockquote>
            <label>Address Line 1</label>
            <input
              type="text"
              placeholder="Enter Address Line 1 (Street Name)"
              required
              name="ShippingAddress.AddressLine1"
              onChange={handleChange}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 200))}
            />
          </blockquote>
          <blockquote>
            <label>Address Line 2</label>
            <input
              type="text"
              placeholder="Enter Address Line 2 (House/Apartment/Flat Name/Number)"
              name="ShippingAddress.AddressLine2"
              onChange={handleChange}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 200))}
            />
          </blockquote>
          <aside>
            <blockquote>
              <label>Country</label>
              <select
                required
                name="ShippingAddress.Country"
                onChange={handleChange}
              >
                <option value="">Select Country</option>
                <option value="India" selected>
                  India
                </option>
              </select>
            </blockquote>
            <blockquote>
              <label>State</label>
              <select
                required
                name="ShippingAddress.State"
                onChange={(e) => {
                  getCitiesbyState(e.target.value);
                  handleChange(e);
                }}
              >
                <option value="">Select State</option>
                {States.map((x) => (
                  <option value={x.id}>{x.name}</option>
                ))}
              </select>
            </blockquote>
            <blockquote>
              <label>City</label>
              <select
                required
                name="ShippingAddress.City"
                onChange={handleChange}
              >
                <option value="">Select City</option>
                {Cities.map((x) => (
                  <option value={x.id}>{x.name}</option>
                ))}
              </select>
            </blockquote>
            <blockquote>
              <label>Pincode</label>
              <input
                type="number"
                placeholder="Enter Pincode"
                required
                name="ShippingAddress.Pincode"
                onChange={handleChange}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 6))}
              />
            </blockquote>
          </aside>
        </div>
        <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
          <input
            type="checkbox"
            name="IsSameAddress"
            onChange={(e) => {
              if (e.target.checked) {
                setEnquiryForm({
                  ...enquiryForm,
                  IsSameAddress: e.target.checked,
                  BillingAddress: {
                    AddressType: enquiryForm.ShippingAddress.AddressType,
                    AddressLine1: enquiryForm.ShippingAddress.AddressLine1,
                    AddressLine2: enquiryForm.ShippingAddress.AddressLine2,
                    Country: enquiryForm.ShippingAddress.Country,
                    State: enquiryForm.ShippingAddress.State,
                    City: enquiryForm.ShippingAddress.City,
                    Pincode: enquiryForm.ShippingAddress.Pincode,
                  },
                });
              } else {
                setEnquiryForm({
                  ...enquiryForm,
                  IsSameAddress: e.target.checked,
                  BillingAddress: {
                    AddressType: "",
                    AddressLine1: "",
                    AddressLine2: "",
                    Country: "",
                    State: "",
                    City: "",
                    Pincode: "",
                  },
                });
              }
            }}
          />
          <label>Is Billing Address Same as Shipping Address?</label>
        </blockquote>
        {enquiryForm.IsSameAddress === false && (
          <div>
            <p>Billing Address</p>
            <blockquote>
              <label>Address Type</label>
              <blockquote
                style={{ flexDirection: "row", alignItems: "center" }}
              >
                <input
                  type="radio"
                  name="BillingAddress.AddressType"
                  value="Office"
                  required
                  onChange={handleChange}
                />
                Office
                <input
                  type="radio"
                  name="BillingAddress.AddressType"
                  value="Factory"
                  required
                  onChange={handleChange}
                />
                Factory
              </blockquote>
            </blockquote>
            <blockquote>
              <label>Address Line 1</label>
              <input
                type="text"
                placeholder="Enter Address Line 1 (Street Name)"
                required
                name="BillingAddress.AddressLine1"
                onChange={handleChange}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 200))}
              />
            </blockquote>
            <blockquote>
              <label>Address Line 2</label>
              <input
                type="text"
                placeholder="Enter Address Line 2 (House/Apartment/Flat Name/Number)"
                name="BillingAddress.AddressLine2"
                onChange={handleChange}
                onInput={(e) => (e.target.value = e.target.value.slice(0, 200))}
              />
            </blockquote>
            <aside>
              <blockquote>
                <label>Country</label>
                <select
                  required
                  name="BillingAddress.Country"
                  onChange={handleChange}
                >
                  <option value="">Select Country</option>
                  <option value="India" selected>
                    India
                  </option>
                </select>
              </blockquote>
              <blockquote>
                <label>State</label>
                <select
                  onChange={(e) => {
                    getCitiesbyState(e.target.value);
                    handleChange(e);
                  }}
                  required
                  name="BillingAddress.State"
                >
                  <option value="">Select State</option>
                  {States.map((x) => (
                    <option value={x.id}>{x.name}</option>
                  ))}
                </select>
              </blockquote>
              <blockquote>
                <label>City</label>
                <select
                  required
                  onChange={handleChange}
                  name="BillingAddress.City"
                >
                  <option value="">Select City</option>
                  {Cities.map((x) => (
                    <option value={x.id}>{x.name}</option>
                  ))}
                </select>
              </blockquote>
              <blockquote>
                <label>Pincode</label>
                <input
                  type="number"
                  placeholder="Enter Pincode"
                  required
                  name="BillingAddress.Pincode"
                  onChange={handleChange}
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 6))}
                />
              </blockquote>
            </aside>
          </div>
        )}
        <div>
          <p>Customer Details</p>
          <blockquote>
            <label>Salutation</label>
            <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
              <input
                type="radio"
                name="Customer.Salutation"
                value="Mr."
                required
                onChange={handleChange}
              />
              Mr.
              <input
                type="radio"
                name="Customer.Salutation"
                value="Mrs."
                required
                onChange={handleChange}
              />
              Mrs.
            </blockquote>
          </blockquote>
          <blockquote>
            <label>Customer Name</label>
            <input
              type="text"
              placeholder="Enter Customer Name"
              required
              name="Customer.Name"
              onChange={handleChange}
              onInput={(e) =>
                (e.target.value = e.target.value
                  .replace(/[^a-zA-Z\s]/g, "")
                  .slice(0, 200))
              }
            />
          </blockquote>
          <blockquote>
            <label>Designation</label>
            <input
              type="text"
              placeholder="Enter Designation"
              required
              name="Customer.Designation"
              onChange={handleChange}
              onInput={(e) =>
                (e.target.value = e.target.value
                  .replace(/[^a-zA-Z\s]/g, "")
                  .slice(0, 200))
              }
            />
          </blockquote>
          <blockquote>
            <label>Phone Number</label>
            <input
              type="number"
              placeholder="Enter Phone Number"
              required
              name="Customer.PhoneNumber"
              onChange={handleChange}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 10))}
            />
          </blockquote>
          <blockquote>
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter Email"
              required
              name="Customer.Email"
              onChange={handleChange}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 200))}
            />
          </blockquote>
        </div>
        <div>
          <p>Customer Boiler</p>
          <blockquote>
            <label>Boiler Head</label>
            <input
              type="text"
              placeholder="Enter Boiler Head"
              required
              name="Boiler.Head"
              onChange={handleChange}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 200))}
            />
          </blockquote>
          <blockquote>
            <label>Boiler Series</label>
            <input
              type="text"
              placeholder="Enter Boiler Series"
              required
              name="Boiler.Series"
              onChange={handleChange}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 100))}
            />
          </blockquote>
        </div>
        <aside>
          <blockquote>
            <label>Enquiry Date</label>
            <input
              type="date"
              required
              value={enquiryForm.EnquiryDate}
              onChange={handleChange}
              name="EnquiryDate"
            />
          </blockquote>
          <blockquote>
            <label>Priority</label>
            <select required name="Priority" onChange={handleChange}>
              <option value="">Select Priority</option>
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
            </select>
          </blockquote>
        </aside>
        <blockquote>
          <label>{enquiryForm.EnquiryType} Looking For</label>
          <textarea
            rows={5}
            required
            name="LookingFor"
            placeholder={`Enter ${
              enquiryForm.EnquiryType === "Service" ? "Services" : "Parts"
            } Looking For (Maximum 800 Characters)`}
            onChange={handleChange}
            onInput={(e) => (e.target.value = e.target.value.slice(0, 800))}
          ></textarea>
        </blockquote>
        <button type="submit">Submit</button>
      </form>
    </section>
  );
}

export default CustomerEnquiryForm;
